var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemplateMapCreation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 121,
    viewBox: "0 0 300 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300 0.00244141H0V120.275H300V0.00244141Z",
    fill: "url(#paint0_linear_290_27914)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.03 65.9803H32.64C30.63 65.9803 29 64.4203 29 62.5003C29 60.5803 30.63 59.0103 32.64 59.0103H95.03C97.04 59.0103 98.67 60.5703 98.67 62.5003C98.67 64.4303 97.04 65.9803 95.03 65.9803Z",
    fill: "url(#paint1_linear_290_27914)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.53 65.97H120.14C118.13 65.97 116.5 64.41 116.5 62.49C116.5 60.57 118.13 59 120.14 59H182.53C184.54 59 186.17 60.56 186.17 62.49C186.17 64.42 184.54 65.97 182.53 65.97Z",
    fill: "url(#paint2_linear_290_27914)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M267.53 65.97H205.14C203.13 65.97 201.5 64.41 201.5 62.49C201.5 60.57 203.13 59 205.14 59H267.53C269.54 59 271.17 60.56 271.17 62.49C271.17 64.42 269.54 65.97 267.53 65.97Z",
    fill: "url(#paint3_linear_290_27914)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.03 77.9803H32.64C30.63 77.9803 29 76.4203 29 74.5003C29 72.5803 30.63 71.0103 32.64 71.0103H95.03C97.04 71.0103 98.67 72.5703 98.67 74.5003C98.67 76.4303 97.04 77.9803 95.03 77.9803Z",
    fill: "url(#paint4_linear_290_27914)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M182.53 77.97H120.14C118.13 77.97 116.5 76.41 116.5 74.49C116.5 72.57 118.13 71 120.14 71H182.53C184.54 71 186.17 72.56 186.17 74.49C186.17 76.42 184.54 77.97 182.53 77.97Z",
    fill: "url(#paint5_linear_290_27914)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M267.53 77.97H205.14C203.13 77.97 201.5 76.41 201.5 74.49C201.5 72.57 203.13 71 205.14 71H267.53C269.54 71 271.17 72.56 271.17 74.49C271.17 76.42 269.54 77.97 267.53 77.97Z",
    fill: "url(#paint6_linear_290_27914)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_290_27914",
    x1: 0,
    y1: 60.1388,
    x2: 300,
    y2: 60.1388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#525EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_290_27914",
    x1: 29,
    y1: 62.4903,
    x2: 98.66,
    y2: 62.4903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_290_27914",
    x1: 116.5,
    y1: 62.49,
    x2: 186.16,
    y2: 62.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_290_27914",
    x1: 201.5,
    y1: 62.49,
    x2: 271.16,
    y2: 62.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_290_27914",
    x1: 29,
    y1: 74.4903,
    x2: 98.66,
    y2: 74.4903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_290_27914",
    x1: 116.5,
    y1: 74.49,
    x2: 186.16,
    y2: 74.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_290_27914",
    x1: 201.5,
    y1: 74.49,
    x2: 271.16,
    y2: 74.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateMapCreation);
export default __webpack_public_path__ + "static/media/template-map-creation.277bebf3.svg";
export { ForwardRef as ReactComponent };